import styles from './AddPrivateKeyButton.module.css';
import AuthenticationContext from 'config/context/authenticationContext';
import { useModalSystem } from 'config/context/ModalSystemContext';
import { KeyIcon } from 'features/permissions/assets/icons';
import React, { useContext } from 'react'

const AddPrivateKeyButton = ({ permission, setTempPrivateKey, hasTempKey }) => {
    const { openModal } = useModalSystem();
    const { isPermissionValid } = useContext(AuthenticationContext);
    const openAuthorizationGuard = () => {
        openModal('AUTHORIZATION_GUARD', { permission: permission, setTempPrivateKey });
    }

    if (isPermissionValid(permission) || hasTempKey) {
        return null;
    }
    return (
        <button onClick={() => openAuthorizationGuard()} className={styles.add_private_key_button}>Add private key <KeyIcon /></button>
    )
}

export default AddPrivateKeyButton;